import React, { useCallback, useContext } from "react";
import GroupContext from "../../context/group";

const FormInput = ({
  type = "text",
  id,
  field,
  label,
  placeholder,
  validate,
  formatWarning,
  isRequired = false,
  ...other
}) => {
  const { formData, onChange, formErrors, setFormErrors } = useContext(GroupContext);
  const currentValue = formData[field];
  const onFocus = useCallback(
    () => setFormErrors((value) => ({ ...value, [field]: null })),
    [setFormErrors, field]
  );
  const onBlur = useCallback(
    (e) => {
      if (validate) {
        setFormErrors((value) => ({
          ...value,
          [field]: !!e.target.value && !validate(e.target.value) ? formatWarning : null,
        }));
      }
    },
    [validate, setFormErrors, field, formatWarning]
  );

  return (
    <label className="form__input-label" htmlFor={id}>
      <span>{label}</span>
      <input
        className="form__input"
        type={type}
        id={id}
        name={field}
        aria-label={label || placeholder}
        value={currentValue}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        data-required={isRequired}
        {...other}
      />
      {formErrors[field] && (
        <span className="form__error-message d-inline">
          {currentValue ? formatWarning : formErrors[field]}
        </span>
      )}
    </label>
  );
};

export default FormInput;
